// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_f0-0";
export var actionModalContentContainer = "_f0-1";
export var createTagButton = "_f0-2";
export var footerContainer = "_f0-7";
export var fullWidthDivider = "_f0-3";
export var hasCreateTagButton = "_f0-4";
export var noCreateTagButton = "_f0-5";
export var tagsContainer = "_f0-6";
export var tagsModalContentContainer = "_f0-8";